import 'bootstrap'; 

jQuery(document).ready(function(){
  var navbar = document.getElementById("navbarLinks");
  var sticky = navbar.offsetTop;
  var navbarHeight = navbar.clientHeight;

  window.onscroll = function() {myFunction()};

  function myFunction() {
    if (window.pageYOffset >= sticky) {
      navbar.classList.add("sticky")
      document.body.style.paddingTop = navbarHeight + "px";
    } else {
      navbar.classList.remove("sticky");
      document.body.style.paddingTop = 0;
    }
  }

    var mainPageSliderLink = document.querySelector('a[href="#mainPageSlider"]');
    if (mainPageSliderLink) {
      mainPageSliderLink.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
});
